'use client'

import { useEffect, useState } from 'react'
import Image from "next/image"
import DefaultLogo from "@/assets/logo.svg"
import { Button } from '@/components/elements/Button'
import { RotateCcw } from 'lucide-react'
import { useParams } from 'next/navigation'
import { sendClientRequest } from '@/utils/client-request'
import { formatImageURL } from '@/utils/util'

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const [vendor, setVendor] = useState<any>(null)
  const params = useParams()
  const domain = params?.domain as string
  useEffect(() => {
    console.error(error)
  }, [error])

  useEffect(() => {
    const fetchVendor = async () => {
      if (domain) {
        try {
          const { data } = await sendClientRequest({ url: `/vendor/public/${domain}`, auth: false })
          setVendor(data)
        } catch (err) {
          console.error('Failed to fetch vendor:', err)
        }
      }
    }

    fetchVendor()
  }, [domain])

  return (
    <div className='h-screen flex flex-col items-center justify-center gap-4'>
      {vendor?.logo ? (
        <img src={formatImageURL(vendor?.logo)} alt="logo" className='h-[28px] sm:h-[34px] w-auto shrink-0 object-cover' />
      ) : (
        <Image src={DefaultLogo} alt="logo" className='h-[28px] sm:h-[34px] w-auto shrink-0 object-cover' loading="eager" priority={true} />
      )}
      <h1 className='font-gilroy text-xl font-semibold'>Шинэчлэлт хийгдэж байна!</h1>
      <p className='text-center text-sm max-w-xs md:max-w-md'>Уучлаарай, системд шинэчлэлт хийгдэж байгаа тул та түр хугацааны дараа дахин оролдоно уу.</p>
      <Button icon={RotateCcw} onClick={() => reset()} color={vendor?.color?.primary} border={vendor?.border}>
        Дахин оролдох
      </Button>
    </div>
  )
}